import { Typography, Paper, Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import React, {useEffect, useState} from 'react';
import {XAxis, YAxis, Tooltip, Legend, Label, LineChart, Line} from 'recharts';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ced8d7",
    paddingBottom: "10px"
  },
  lineGraphTitle: {
    paddingTop: "15px",
    marginTop: "10px",
  },
  pieTitle: {
    paddingTop: "15px",
    marginTop: "10px",
    marginBottom: "-30px",
    textAlign: "center"
  },

}));

const Map2Plots = (props) => {
const classes = useStyles();
const graphData = props.graphData;
const [newGraphData, setNewGraphData] = useState(0);

useEffect(() => {
if (graphData !== null) {
 setNewGraphData({
    name :  graphData.properties.NAME,

    ag_2013_area_km2: graphData.properties.ag_2013_area_km2,
    ag_2013_mean: graphData.properties.ag_2013_mean,
    ag_2016_area_km2: graphData.properties.ag_2016_area_km2,
    ag_2016_mean: graphData.properties.ag_2016_mean,
    ag_2020_area_km2: graphData.properties.ag_2020_area_km2,
    ag_2020_mean: graphData.properties.ag_2020_mean,
    area_km : graphData.properties.area_km,
    trans_2013_area_km2: graphData.properties.trans_2013_area_km2,
    trans_2013_mean: graphData.properties.trans_2013_mean,
    trans_2016_area_km2: graphData.properties.trans_2016_area_km2,
    trans_2016_mean: graphData.properties.trans_2016_mean,
    trans_2020_area_km2: graphData.properties.trans_2020_area_km2,
    trans_2020_mean: graphData.properties.trans_2020_mean,
    urban_2013_area_km2: graphData.properties.urban_2013_area_km2,
    urban_2013_mean: graphData.properties.urban_2013_mean,
    urban_2016_area_km2: graphData.properties.urban_2016_area_km2,
    urban_2016_mean: graphData.properties.urban_2016_mean,
    urban_2020_area_km2: graphData.properties.urban_2020_area_km2,
    urban_2020_mean: graphData.properties.urban_2020_mean,
 })
}
}, [graphData]);

const data = [
  { date: "2013", Agriculture: Math.round(newGraphData.ag_2013_area_km2), Transportation: Math.round(newGraphData.trans_2013_area_km2), Energy: 0, Urban: Math.round(newGraphData.urban_2013_area_km2) },
  { date: "2016", Agriculture: Math.round(newGraphData.ag_2016_area_km2), Transportation: Math.round(newGraphData.trans_2016_area_km2), Energy: 0, Urban: Math.round(newGraphData.urban_2016_area_km2) },
  { date: "2020", Agriculture: Math.round(newGraphData.ag_2020_area_km2), Transportation: Math.round(newGraphData.trans_2020_area_km2), Energy: 0, Urban: Math.round(newGraphData.urban_2020_area_km2) },
];

const data2 = [
  { date: "2013", Agriculture: Math.round(newGraphData.ag_2013_mean), Transportation: Math.round(newGraphData.trans_2013_mean), Energy: 0, Urban: Math.round(newGraphData.urban_2013_mean) },
  { date: "2016", Agriculture: Math.round(newGraphData.ag_2016_mean), Transportation: Math.round(newGraphData.trans_2016_mean), Energy: 0, Urban: Math.round(newGraphData.urban_2016_mean) },
  { date: "2020", Agriculture: Math.round(newGraphData.ag_2020_mean), Transportation: Math.round(newGraphData.trans_2020_mean), Energy: 0, Urban: Math.round(newGraphData.urban_2020_mean) },
];

    return (
      <div className={classes.root}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            
            <Paper elevation={3} style={{ marginTop: "12px" }}>
              <Typography
                className={classes.lineGraphTitle}
                align="center"
                variant="subtitle1"
              >
                <b>Percent of Land Impacted in {newGraphData.name}</b>
              </Typography>
              <div className="area-chart-wrapper">
                <LineChart
                  width={545}
                  height={330}
                  data={data2}
                  margin={{ top: 50, right: 40, left: 24, bottom: 20 }}
                >
                  <YAxis>
                    <Label position="insideTop" offset={-25}>
                      Percent (%)
                    </Label>
                  </YAxis>
                  <XAxis dataKey="date" interval={0}>
                    <Label position="insideBottom" offset={-6}>
                      Year
                    </Label>
                  </XAxis>
                  <Legend verticalAlign="insideTop" align="right" height={35} />
                  <Tooltip />
                  <Line
                    dataKey="Agriculture"
                    type="monotone"
                    stackId="1"
                    stroke="#597d35"
                    fill="#597d35"
                    strokeWidth={1}
                  />
                  <Line
                    dataKey="Transportation"
                    type="monotone"
                    stackId="1"
                    stroke="#004983"
                    fill="#004983"
                    strokeWidth={1}
                  />
                  {/* <Area
                    dataKey="Energy"
                    type="monotone"
                    stackId="1"
                    stroke="rgb(246, 122, 55)"
                    fill="rgb(246, 122, 55)"
                    strokeWidth={2}
                  /> */}
                  <Line
                    dataKey="Urban"
                    type="monotone"
                    stackId="1"
                    stroke="#000000"
                    fill="#000000"
                    strokeWidth={1}
                  />
                </LineChart>
              </div>
            </Paper>

            <Paper elevation={3} style={{ marginTop: "15px" }}>
              <Typography
                className={classes.lineGraphTitle}
                align="center"
                variant="subtitle1"
              >
                <b>Anthropogenic Impact in {newGraphData.name}</b>
              </Typography>
              <div className="area-chart-wrapper">
                <LineChart
                  width={545}
                  height={330}
                  data={data}
                  margin={{ top: 50, right: 40, left: 24, bottom: 20 }}
                >
                  <YAxis>
                    <Label position="insideTop" offset={-42}>
                      Area Impacted
                    </Label>
                    <Label position="insideTop" offset={-25}>
                      km²
                    </Label>
                  </YAxis>
                  <XAxis dataKey="date" interval={0}>
                    <Label position="insideBottom" offset={-6}>
                      Year
                    </Label>
                  </XAxis>
                  <Legend verticalAlign="insideTop" align="right" height={35} />
                  <Tooltip />
                  <Line
                    dataKey="Agriculture"
                    type="monotone"
                    stackId="1"
                    stroke="#597d35"
                    fill="#597d35"
                    strokeWidth={1}
                  />
                  <Line
                    dataKey="Transportation"
                    type="monotone"
                    stackId="1"
                    stroke="#004983"
                    fill="#004983"
                    strokeWidth={1}
                  />
                  {/* <Area
                    dataKey="Energy"
                    type="monotone"
                    stackId="1"
                    stroke="rgb(246, 122, 55)"
                    fill="rgb(246, 122, 55)"
                    strokeWidth={2}
                  /> */}
                  <Line
                    dataKey="Urban"
                    type="monotone"
                    stackId="1"
                    stroke="#000000"
                    fill="#000000"
                    strokeWidth={1}
                  />
                </LineChart>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
}

export default Map2Plots
